import React from 'react';
import classnames from 'classnames';

export type MembershipCardInfoProps = {
  firstHeader?: string;
  secondHeader?: string;
  supplementalText?: string;
  primaryText?: string;
  secondText?: string;
  noMembership?: boolean;
};

const MembershipCardInfo = ({
  firstHeader,
  secondHeader,
  supplementalText,
  primaryText,
  secondText,
  noMembership,
}: MembershipCardInfoProps) => {
  return (
    <div className={classnames('MembershipCardInfo', { noMembership })}>
      {firstHeader ? <h5 className='firstHeader'>{firstHeader}</h5> : null}
      <div className='secondContainer'>
        {secondHeader ? <h2 className='secondHeader'>{secondHeader}</h2> : null}
        {secondText ? <p className='secondText'>{secondText}</p> : null}
      </div>
      {primaryText ? <p className='primaryText'>{primaryText}</p> : null}
      {supplementalText ? (
        <p className='supplementalText'>{`(${supplementalText})`}</p>
      ) : null}
    </div>
  );
};

export default MembershipCardInfo;
